// extracted by mini-css-extract-plugin
module.exports = {"message":"message-33-jQXcZ"};